// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".InputValidation-module__formContainer___2-iEA{width:100%;display:flex}.InputValidation-module__formContainer___2-iEA .InputValidation-module__inputContainer___hC3cr{width:80%;flex:0 0 65%;padding-right:10px}.InputValidation-module__skipContainer___1vqRT{padding-top:15px;padding-bottom:40px}", ""]);
// Exports
exports.locals = {
	"formContainer": "InputValidation-module__formContainer___2-iEA",
	"inputContainer": "InputValidation-module__inputContainer___hC3cr",
	"skipContainer": "InputValidation-module__skipContainer___1vqRT"
};
module.exports = exports;
